/**
 * Configuração dos filtros para a listagem de pedidos
 */
export const filterConfig = [
  {
    id: 'Titulo',
    type: 'text',
    label: 'Titulo',
    placeholder: 'Digite o titulo da vaga'
  },
  {
    id: 'Data_abertura',
    type: 'date',
    label: 'Data de abertura'
  },
  {
    id: 'NecessitaCNH',
    type: 'searchSelect',
    label: 'Necessita CNH?',
    placeholder: 'Selecione...',
    options: [
      { label: 'Sim', value: '1' },
      { label: 'Não', value: '0' },
    ],
    defaultValue: '', // manter sem filtro
  }
];
